import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Row, Col } from 'antd'
import { compose } from 'recompose'
import _ from 'lodash'
import moment from 'moment'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { dashboardData } = this.props

		const total_constituents = _.has(dashboardData, 'total_constituents') ? dashboardData.total_constituents : 0
		const total_household = _.has(dashboardData, 'total_household') ? dashboardData.total_household : 0
		// const total_certificates = _.has(dashboardData, 'total_certificates') ? dashboardData.total_certificates : 0
		// const total_clearances = _.has(dashboardData, 'total_clearances') ? dashboardData.total_clearances : 0
		// const average_household_size = _.has(dashboardData, 'average_household_size') ? dashboardData.average_household_size : 0
		return (
			<React.Fragment>
				<div className="col-xl-6 col-md-6">
					<div className="card widget-box-two bg-purple">
						<div className="card-body">
							<div className="media">
								<div className="media-body wigdet-two-content">
									<p className="m-0 text-uppercase text-white" title="Statistics">Households</p>
									<h2 className="text-white"><span data-plugin="counterup">{total_household}</span> <i className="fe-users text-white font-22"></i></h2>
									{/* <p className="text-white m-0"><b>10%</b> From previous period</p> */}
								</div>
								<div className="avatar-lg rounded-circle bg-soft-light ml-2 align-self-center">
									<i className="fe-users font-22 avatar-title text-white"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-6 col-md-6">
					<div className="card widget-box-two bg-info">
						<div className="card-body">
							<div className="media">
								<div className="media-body wigdet-two-content">
									<p className="m-0 text-white text-uppercase" title="User Today">Constituents</p>
									<h2 className="text-white"><span data-plugin="counterup">{total_constituents}</span> <i className="fe-user text-white font-22"></i></h2>
									{/* <p className="text-white m-0"><b>5.6%</b> From previous period</p> */}
								</div>
								<div className="avatar-lg rounded-circle bg-soft-light ml-2 align-self-center">
									<i className="fe-user  font-22 avatar-title text-white"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* <div className="col-xl-3 col-md-6">
					<div className="card widget-box-two bg-primary">
						<div className="card-body">
							<div className="media">
								<div className="media-body wigdet-two-content">
									<p className="m-0 text-white text-uppercase" title="User Today">Average Household</p>
									<h2 className="text-white"><span data-plugin="counterup">{average_household_size}</span> <i className="fe-users text-white font-22"></i></h2>
								</div>
								<div className="avatar-lg rounded-circle bg-soft-light ml-2 align-self-center">
									<i className="fe-users  font-22 avatar-title text-white"></i>
								</div>
							</div>
						</div>
					</div>
				</div> */}
				{/* <div className="col-xl-4 col-md-6">
					<div className="card widget-box-two bg-success">
						<div className="card-body">
							<div className="media">
								<div className="media-body wigdet-two-content">
									<p className="m-0 text-uppercase text-white" title="Request Per Minute">Certificates/Clearances</p>
									<h2 className="text-white"><span data-plugin="counterup">{(total_certificates + total_clearances)}</span> <i className="mdi mdi-file-pdf-outline text-white font-22"></i></h2>
								</div>
								<div className="avatar-lg rounded-circle bg-soft-light ml-2 align-self-center">
									<i className="mdi mdi-file-pdf-outline font-22 avatar-title text-white"></i>
								</div>
							</div>
						</div>
					</div>
				</div> */}
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
